import { render } from "./CaptionedPairImage.vue?vue&type=template&id=1045c1ba"
import script from "./CaptionedPairImage.vue?vue&type=script&lang=ts"
export * from "./CaptionedPairImage.vue?vue&type=script&lang=ts"
script.render = render

export default script